import React from 'react';
import { useState, useEffect } from 'react';
import './TrainingPage.css';
import TrainingContainer from './components/TrainingContainer';
import Part1Training from './components/Part1Training';
import Part2Training from './components/Part2Training';
import Part3Training from './components/Part3Training';
import { useLanguage } from './contexts/LanguageContext';

// 生成随机会话ID
const generateSessionId = () => {
  return 'guest_' + Math.random().toString(36).substring(2, 15);
};

const TrainingPage = ({ deadline, username, purpose, mode }) => {
  const { language } = useLanguage();
  const [selectedPart, setSelectedPart] = useState('part1');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [sessionId, setSessionId] = useState('');

  // 检查用户登录状态
  useEffect(() => {
    const storedUser = localStorage.getItem('talktastic_user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user && user.isRegistered) {
          setIsLoggedIn(true);
          setUserData(user);
          // 登录用户使用邮箱作为唯一标识
          setSessionId(user.email);
        } else {
          // 游客模式 - 检查或创建会话ID
          initGuestSession();
        }
      } catch (error) {
        console.error('读取用户信息失败:', error);
        // 游客模式 - 检查或创建会话ID
        initGuestSession();
      }
    } else {
      // 游客模式 - 检查或创建会话ID
      initGuestSession();
    }
  }, []);

  // 初始化游客会话
  const initGuestSession = () => {
    let guestId = localStorage.getItem('talktastic_guest_id');
    if (!guestId) {
      guestId = generateSessionId();
      localStorage.setItem('talktastic_guest_id', guestId);
    }
    setSessionId(guestId);
    
    // 同时记录游客会话创建时间，用于实现3天自动过期
    const now = new Date().toISOString();
    localStorage.setItem('talktastic_guest_created', now);
  };

  // 根据mode设置目的
  const trainingPurpose = mode === 'mockTest' ? 'Mock Test' : 
                          mode === 'simulation' ? 'Simulation Training' : 
                          purpose || 'IELTS';

  // 根据登录状态决定用户名和倒计时
  const displayUsername = isLoggedIn && userData?.username ? userData.username : "You";
  const displayDeadline = isLoggedIn && userData?.ieltsDeadline ? userData.ieltsDeadline : null;

  return (
    <TrainingContainer 
      deadline={displayDeadline} 
      username={displayUsername} 
      purpose={trainingPurpose}
      selectedPart={selectedPart}
      setSelectedPart={setSelectedPart}
      mode={mode}
      isLoggedIn={isLoggedIn}
      sessionId={sessionId}
    >
      {selectedPart === 'part1' && <Part1Training username={displayUsername} mode={mode} />}
      {selectedPart === 'part2' && <Part2Training username={displayUsername} mode={mode} />}
      {selectedPart === 'part3' && <Part3Training username={displayUsername} mode={mode} />}
    </TrainingContainer>
  );
};

export default TrainingPage; 